// extracted by mini-css-extract-plugin
module.exports = {"capital":"userGroupsTerm_capital__3mx5J","lower":"userGroupsTerm_lower__4Y8qh"};